// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("D:\\Documents\\Projects\\jambp\\node_modules\\gatsby-plugin-offline\\app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-index-tsx": () => import("D:\\Documents\\Projects\\jambp\\src\\pages\\index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-second-tsx": () => import("D:\\Documents\\Projects\\jambp\\src\\pages\\second.tsx" /* webpackChunkName: "component---src-pages-second-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "D:\\Documents\\Projects\\jambp\\.cache\\data.json")

